__webpack_require__.p = "//prod.smassets.net/assets/smweb/_next/";